import { render } from "./MessageModal.vue?vue&type=template&id=15a24766&scoped=true"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"

import "./MessageModal.vue?vue&type=style&index=0&id=15a24766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a24766"]])

export default __exports__